import AppGallery from 'assets/images/app_gallery.svg';
import AppStore from 'assets/images/app_store.svg';
import GooglePlay from 'assets/images/google_play.svg';
import RuStore from 'assets/images/rustore.svg';

export const VERSION_VALIDATION_RULE = {
  required: 'Поле обязательно для заполнения',
  pattern: {
    value: /^\d+\.\d+\.\d+$/,
    message: 'Неверный формат версии (требуется x.x.x)',
  },
};

export const PLATFORMS = ['APPSTORE', 'GOOGLEPLAY', 'APPGALLERY', 'RUSTORE'];
export const PLATFORM_ICONS: { [key: string]: string } = {
  APPSTORE: AppStore,
  GOOGLEPLAY: GooglePlay,
  APPGALLERY: AppGallery,
  RUSTORE: RuStore,
};
